import React from "react";
import PageLoader from "../../../../components/PageLoader";
import { getSelectedLayout } from "../defaultLayoutData";
import "./style.scss";

class LandingPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const previewData = localStorage.getItem("previewData");
    if (previewData) {
      const parsed = JSON.parse(previewData);
      this.setState(parsed);
    } else {
      setTimeout(() => {
        this.props.history.push("/admin/campaign");
      }, 2000);
    }
  }

  componentWillUnmount() {
    this.setState({});
  }

  render() {
    const { isDesktopPreview, landingSettings, selectedLayout } = this.state;
    if (Object.keys(this.state).length === 0) {
      return <PageLoader />;
    }
    return (
      <div style={{ backgroundColor: "#d9d9d9" }}>
        <div
          className={
            isDesktopPreview
              ? "area previewMode bg-white"
              : "area previewMode mobileView"
          }
        >
          {isDesktopPreview ? (
            getSelectedLayout(
              landingSettings,
              selectedLayout,
              isDesktopPreview,
              true
            )
          ) : (
            <div
              style={{
                height: "650px",
                position: "relative",
                top: "50%",
                transform: "translateY(-50%)",
                backgroundColor: "#fff",
              }}
            >
              {getSelectedLayout(
                landingSettings,
                selectedLayout,
                isDesktopPreview,
                true
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default LandingPreview;
